import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
export function TrippinThroughLifePrivacyPage() {
  return <div className="min-h-screen bg-gradient-to-b from-blush-50 via-white to-peach-50 pt-28 pb-24" data-id="element-1254" data-mp="3jiolswhpagho">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1255" data-mp="3ofoulf5xpxch">
        {/* Back link */}
        <Link to="/apps/trippin-through-life" className="inline-flex items-center gap-2 text-plum-500 hover:text-plum-700 font-medium mb-8 transition-colors" data-id="element-1256" data-mp="2qtrbpgnn7q00">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-1257" data-mp="30qm9tyg07odr" />
          Back to Trippin' Through Life
        </Link>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-1258" data-mp="35r08wqzmnnzn">
          <div className="w-14 h-14 rounded-2xl bg-blush-100 flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-1259" data-mp="l2471woh7nxj">
            <ShieldCheckIcon className="w-7 h-7 text-cta-500" data-id="element-1260" data-mp="28l96zyrfufi5" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-plum-800 mb-3" data-id="element-1261" data-mp="28j66ulwkn5zp">
            Privacy Policy
          </h1>
          <p className="text-plum-500 font-medium" data-id="element-1262" data-mp="1zkuhsobcsg9d">
            Trippin' Through Life — Effective May 12, 2026
          </p>
        </motion.div>

        {/* Content */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-blush-100" data-id="element-1263" data-mp="1unkmis1a9adm">
          <div className="prose prose-plum max-w-none text-plum-600 text-sm leading-relaxed space-y-6" data-id="element-1264" data-mp="1psoggnz7omhi">
            <p data-id="element-1265" data-mp="1ktloo588scrh">
              Trippin' Through Life ("we," "our," or "us") respects your privacy
              and is committed to protecting your personal information. This
              Privacy Policy explains how information may be collected, used,
              and protected when using the Trippin' Through Life mobile
              application and related services.
            </p>
            <p data-id="element-1266" data-mp="x6zvfncquaj6">
              Trippin' Through Life is an AI-powered life management and
              organization app designed to help users manage schedules,
              routines, household tasks, reminders, goals, wellness, travel
              planning, and productivity.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1267" data-mp="s9ghypnve1sa">
              Information We May Collect
            </h3>
            <p data-id="element-1268" data-mp="1kxvsozzyxxxt">Depending on how you use the app, we may collect:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-1269" data-mp="1kx3x3p6dg07j">
              <li data-id="element-1270" data-mp="169istrxrfuy1">Account information such as email address or username</li>
              <li data-id="element-1271" data-mp="1b82ia2bkbov5">Household setup information entered by the user</li>
              <li data-id="element-1272" data-mp="1b69d6rgllcp9">Scheduling, reminder, and checklist data</li>
              <li data-id="element-1273" data-mp="1ywlrql6cm7ot">Calendar-related permissions if enabled by the user</li>
              <li data-id="element-1274" data-mp="23o3ikgenqrw2">Notification preferences</li>
              <li data-id="element-1275" data-mp="23py15o2gi7wz">
                Device information such as device type, operating system, and
                crash reports
              </li>
              <li data-id="element-1276" data-mp="3jfyz2dxs7m2q">Anonymous analytics and usage information</li>
              <li data-id="element-1277" data-mp="3jffip1ns55qt">
                Optional location permissions for maps, reminders, or
                travel-related features
              </li>
            </ul>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1278" data-mp="3t6ju5re8y8gw">
              How We Use Information
            </h3>
            <p data-id="element-1279" data-mp="35g6cmutafs0k">Information collected may be used to:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-1280" data-mp="30hcvmseslivn">
              <li data-id="element-1281" data-mp="30ixtos0bfjy9">
                Provide app functionality and personalized organization systems
              </li>
              <li data-id="element-1282" data-mp="3af0sbnvyl0gg">
                Generate schedules, reminders, routines, and task
                recommendations
              </li>
              <li data-id="element-1283" data-mp="tpltzhgobngv">Improve AI-powered planning and productivity features</li>
              <li data-id="element-1284" data-mp="pp1y0h7u6pwb">Save preferences, progress, and household settings</li>
              <li data-id="element-1285" data-mp="pr4o118zoj11">Improve app stability, usability, and performance</li>
              <li data-id="element-1286" data-mp="1l0jbpysukner">Respond to support requests and feedback</li>
              <li data-id="element-1287" data-mp="1p00j4xru3umk">Prevent abuse or misuse of the platform</li>
            </ul>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1288" data-mp="1tzmx59fhlewf">
              AI & Automation Features
            </h3>
            <p data-id="element-1289" data-mp="1yyzs6hgihsa3">
              Certain features within Trippin' Through Life may use AI-generated
              recommendations, scheduling systems, or automation tools based on
              information voluntarily entered by the user. Users remain
              responsible for reviewing and managing their own schedules,
              reminders, and decisions.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1290" data-mp="2hoxxwqwu79ak">
              Data Sharing
            </h3>
            <p data-id="element-1291" data-mp="2mp3n80fmwjph">We do not sell personal information to third parties.</p>
            <p data-id="element-1292" data-mp="2rnexgc9ucw88">
              Some third-party services used by the app, including
              authentication providers, cloud storage, analytics platforms,
              payment processors, advertisements, maps, or notification systems,
              may process limited information required for app functionality.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1293" data-mp="62x65n1p6gyo">
              Calendar & Notification Permissions
            </h3>
            <p data-id="element-1294" data-mp="14vs5gj4p7u2">
              If enabled by the user, the app may request access to calendar
              functions, notifications, or location-based services in order to
              provide reminders, scheduling tools, travel support, or map
              integrations. These permissions are optional and can typically be
              disabled within device settings.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1295" data-mp="k1dfllqy2lki">
              User Content
            </h3>
            <p data-id="element-1296" data-mp="1hivoyimoghd3">
              Checklists, schedules, notes, goals, household information, and
              other content entered into the app may be stored to support
              personalization and saved progress. Users are responsible for the
              information they choose to store within the app.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1297" data-mp="2x8v7f65lyhl6">
              Children's Privacy
            </h3>
            <p data-id="element-1298" data-mp="326em2767wwdn">
              Trippin' Through Life is not directed toward children under the
              age of 13. We do not knowingly collect personal information from
              children under 13.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1299" data-mp="2sal94mol70vc">
              Data Security
            </h3>
            <p data-id="element-1300" data-mp="2ebtyja8xnxby">
              We take reasonable measures to help protect user information and
              maintain platform security. However, no digital system can
              guarantee complete security.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1301" data-mp="hhqtkurzdjhz">
              Account & Data Removal
            </h3>
            <p data-id="element-1302" data-mp="220b0e4b1t4m7">
              Users may request account or data deletion by contacting: <br data-id="element-1303" data-mp="1x0oopzavbwfi" />
              <strong data-id="element-1304" data-mp="1x17vqkyzd0er">Email:</strong> trippinwithmandy@gmail.com
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1305" data-mp="2bpkxxzonvfhp">
              Changes to This Policy
            </h3>
            <p data-id="element-1306" data-mp="26xkqlm69hkb3">
              This Privacy Policy may be updated periodically. Continued use of
              the app after updates constitutes acceptance of the revised
              policy.
            </p>

            <h3 className="text-plum-800 font-bold text-base mt-8 mb-3" data-id="element-1307" data-mp="2fq4qepyahuxi">
              Contact
            </h3>
            <p data-id="element-1308" data-mp="2un5joxw4pxy3">
              For questions regarding this Privacy Policy, contact: <br data-id="element-1309" data-mp="2ppvkwrmuo9xl" />
              <strong data-id="element-1310" data-mp="2pplw37djk8th">Trippin' with Mandy Email:</strong>{' '}
              trippinwithmandy@gmail.com
            </p>
          </div>
        </div>
      </div>
    </div>;
}